var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('div',{staticClass:"pagination-l"},[_vm._v(" 共"+_vm._s(_vm.total)+"条记录 ")]),_c('el-pagination',{attrs:{"background":"","total":this.total,"page-size":this.pageSize,"layout":"prev, pager, next, jumper","hide-on-single-page":""},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }